<template>
  <div class="mt-3">
    <b-overlay :show="loading">
      <b-form @submit.stop.prevent="sendNotification">
        <b-form-group :label="'Employee'">
          <b-form-select v-model="fdata.employee_id" class="mb-3">
            <b-form-select-option :value="null">Please select an option</b-form-select-option>
            <b-form-select-option v-for="employee in employees" :key="employee.employee_id" :value="employee.employee_id">{{ employee.name }}</b-form-select-option>
          </b-form-select>
        </b-form-group>

        <b-form-group label="Title">
          <b-form-input v-model="fdata.title"></b-form-input>
        </b-form-group>

        <b-form-group label="Body">
          <b-form-textarea class="my-2" v-model="fdata.body"></b-form-textarea>
        </b-form-group>

        <b-button type="submit"> Send Notification</b-button>
      </b-form>
    </b-overlay>
  </div>
</template>

<script>
export default {
  data(){
    return {
      loading: false,
      employees: [],
      fdata: {
        employee_id: null,
        title: '',
        body:'',
      }
    };
  },
  methods:{
    sendNotification()
    {
      if(this.fdata.employee_id == null)
      {
        this.$bvToast.toast(
            'Select an employee',{
              solid: true,
              variant: 'danger',
              title: "Failed!"
            }
        );
      }
      let formData = new FormData();
      // formData.append('employee_id', this.fdata.employee_id);
      formData.append('employee_id', this.fdata.employee_id);
      formData.append('title', this.fdata.title);
      formData.append('body', this.fdata.body);
      this.loading = true;  

      axios.post(this.$api_url + '/notification/send', formData).then(response => {
        this.$bvToast.toast(
            'Successfully sent',{
              solid: true,
              variant: 'success',
              title: "Success"
            }
        );

        this.loading = false;  
      }).catch(e => {
        this.loading = false;  
      });
    },
    getEmployees()
    {
      axios.get(this.$api_url + '/notification/employees').then(response => {
        this.employees = response.data
      });
    }
  },
  mounted(){
    this.getEmployees();
  }
}
</script>

<style scoped>

</style>